import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "@websential/cosmic-v20";

import { IFilingResourceListModel } from "../models/filingResource";
import { IFilingResourceRequestPayload } from "../models/filingResource/IFilingResourceRequestPayload";
import { IFilingResourceResponsePayload } from "../models/filingResource/IFilingResourceResponsePayload";
import { IGetListRequest } from "../models";
import http from "../common/http-commons";

let clientIdNew = "";
export const FilingResourceService = {
  create: async (
    requestPayload: IFilingResourceRequestPayload,
  ): Promise<IFilingResourceResponsePayload | IServerError | IResponse> => {
    if (requestPayload.id) {
      const response: AxiosResponse<IFilingResourceResponsePayload> | any =
        await http.post<IFilingResourceResponsePayload>(
          // `/v1/filing-resources/${requestPayload.id}/`,
          // requestPayload
          "/v1/filing-resources/",
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response;
      } else if (response.status === 404) {
        return response;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    }

    // if(requestPayload.role){

    //   }
    const response: AxiosResponse<IFilingResourceResponsePayload> | any =
      await http.post<IFilingResourceResponsePayload>(
        "/v1/filing-resources/",
        requestPayload,
      );

    if (response.status === 201) {
      return response;
    } else if (response.status === 400) {
      return response;
    } else if (response.status === 404) {
      return response;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getList: async (
    clientId: string,
    params: IGetListRequest,
  ): Promise<IFilingResourceListModel | IServerError | IResponse | any> => {
    // const fixedResponse: IFilingResourceListModel = {
    //   "page": 1,
    //   "size": 5,
    //   "total": 2,
    //   "items": [
    //     {
    //       "id": "ab8ccece-16c1-44e9-ba86-2990eefb178c",
    //       "name": "Babar Javaid",
    //       "selectedRoles": "Contact Person, Issuer, Transmitter",
    //       "appliedYear": 2020
    //     },
    //     {
    //       "id": "4e3823aa-c2e4-45aa-aaaf-9ba1b1486acc",
    //       "name": "Bilal Khan",
    //       "selectedRoles": "Contact Person, Transmitter",
    //       "appliedYear": 2020
    //     }
    //   ],
    //   "keyField": {
    //     "field": "id",
    //     "templateUrl": "/filing-resources/setup/id"
    //   },
    //   "headerColumns": [
    //     {
    //       "field": "name",
    //       "headerName": "Name",
    //       "description": "Name",
    //       "flex": 1,
    //       "hide": false,
    //       "hideable": false,
    //       "sortable": true,
    //       // "sortingOrder": "asc",
    //       "resizable": false,
    //       "type": "string",
    //       "align": "left",
    //       "headerAlign": "left",
    //       "hideSortIcons": false,
    //       "disableColumnMenu": true,
    //       "disableReorder": true,
    //       "disableExport": true,
    //       "maskable": false,
    //       // "isFixed": true,
    //       "sequence": 0
    //     },
    //     {
    //       "field": "selectedRoles",
    //       "headerName": "Role(s)",
    //       "description": "Role(s) Assigned",
    //       "flex": 1,
    //       "hide": false,
    //       "hideable": false,
    //       "sortable": true,
    //       // "sortingOrder": "asc",
    //       "resizable": false,
    //       "type": "string",
    //       "align": "left",
    //       "headerAlign": "left",
    //       "hideSortIcons": false,
    //       "disableColumnMenu": true,
    //       "disableReorder": true,
    //       "disableExport": true,
    //       "maskable": false,
    //       // "displayMode": "Chip",
    //       // "chipColors": ["#0091b3", "#36b37e", "#e0e0e0"],
    //       // "isFixed": true,
    //       "sequence": 1
    //     },
    //     {
    //       "field": "appliedYear",
    //       "headerName": "Applied from Year",
    //       "description": "Applied from Year",
    //       "flex": 1,
    //       "hide": false,
    //       "hideable": false,
    //       "sortable": true,
    //       // "sortingOrder": "asc",
    //       "resizable": false,
    //       "type": "string",
    //       "align": "left",
    //       "headerAlign": "left",
    //       "hideSortIcons": false,
    //       "disableColumnMenu": true,
    //       "disableReorder": true,
    //       "disableExport": true,
    //       "maskable": false,
    //       // "isFixed": true,
    //       "sequence": 2
    //     }
    //   ]
    // }
    // return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));

    const response: AxiosResponse<IFilingResourceListModel> =
      await http.get<IFilingResourceListModel>(
        `/v1/filing-resources/?client_id=${clientId}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`,
      );

    if (response.status === 200) {
      clientIdNew = clientId;
      return response.data;
    } else if (response.status === 400) {
      return {
        status: false,
        message: "Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  delFilingResource: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/filing-resources/${delPayload.filingResourceId}/?client_id=${delPayload.clientId}`,
      );

      if (response.status === 204) {
        return "Filing Resource has been deleted successfully";
      } else if (response.status === 200) {
        return "Filing Resource has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  // getSetupLayout: async (): Promise<any> => {
  //   let response: any = FILLING_RESOURCE_SETUP_FORM;
  //   return new Promise(resolve => setTimeout(() => resolve(response), 1000));
  // },

  getById: async (
    id: string | undefined,
    clientId: string,
  ): Promise<
    IFilingResourceListModel | IServerError | IResponse | null | any
  > => {
    if (!id) return null;
    const response: AxiosResponse<IFilingResourceListModel> =
      await http.get<IFilingResourceListModel>(
        `/v1/filing-resources/${id}/?client_id=${clientId}`,
      );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveFilingResource: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/departments/${archivePayload.departmentsId}/`,
      );

      if (response.status === 201) {
        return "Filing Resource has been archived successfully";
      } else if (response.status === 200) {
        return "Filing Resource has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getfilingResourceDDL: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/filing-resources/ddl?client_id=${clientId}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
};
